module.exports = __webpack_public_path__ + "img/admit1.9e9f2b8c.png";